import { Box, Button } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import type { ContentStackJSONRichText } from '../../../../utils/requests/contentstack/contentStackZodSchema';
import { isEmpty, JsonRteRenderer } from '../../../../components/JsonRteRenderer';
import styles from './styles.module.scss';
import { CloudinaryImageWrapper, type CloudinaryImageFields } from '../../../../components/CloudinaryImageWrapper';
export type Theme = {
  backgroundColor: 'mint-60' | 'blue-45' | 'gray-99' | 'citrus-60' | 'forest-60' | 'grapefruit-60' | 'cerulean-60' | 'white';
  textColor: 'mint-60' | 'blue-45' | 'forest-60' | 'white' | 'citrus-60';
};
export type ShopCategoryPromoCard = {
  textColor: Theme['textColor'];
  backgroundColor: Theme['backgroundColor'];
  content: ContentStackJSONRichText;
  cta: {
    text: string;
    href: string;
  };
  gridPositions: number[];
  alignContent: 'top' | 'bottom' | 'center';
  image: CloudinaryImageFields & {
    size: 'small' | 'full';
  };
};
export type PromoCardProps = Omit<ShopCategoryPromoCard, 'gridPositions'>;
const getImageSize = (size: 'small' | 'full') => {
  switch (size) {
    case 'small':
      return 40;
    case 'full':
    default:
      return 300;
  }
};
export const PromoCard = ({
  backgroundColor,
  textColor,
  content,
  cta,
  alignContent,
  image
}: PromoCardProps) => <Box bgColor={backgroundColor} data-testid="shop-category-promo-card" className={classNames(styles.promoCard, styles[`align-${alignContent}`])}>
    <Box className={styles.imageContainer}>
      <CloudinaryImageWrapper alt={image.alt} src={image.src} aspectRatio={image.aspectRatio} lazy cloudinaryAsset={image.cloudinaryAsset} sizes={[{
      minWidth: 0,
      staticWidth: getImageSize(image.size)
    }]} sources={{
      sm: getImageSize(image.size)
    }} />
    </Box>

    {!isEmpty(content?.children) && <Box>
        <JsonRteRenderer data={content} options={{
      textProps: {},
      color: textColor
    }} />
      </Box>}

    {cta.href && cta.text && <span>
        <Button as="a" href={cta.href} variant="filled-staple" width={{
      sm: 'fit',
      md: 'fit',
      lg: 'fixed'
    }}>
          {cta.text}
        </Button>
      </span>}
  </Box>;